<template>
  <div>
    <div class="Intro">
      <div class="IdBlock" v-if="user.id">

        <div class="AvaBig" :style='{ backgroundImage: `url(${user.avatar_220})` }'></div>
        <div class="AvaBt" @click="$refs.avatar.click()" v-if="showEditLink && user.id">Загрузить фото</div>

        <input type="file" ref="avatar" @change="uploadAvatar" style="display: none" accept="image/*">
        <div class="IdStatus" :class="user.role">{{ roles[user.role] }}</div>
        <div class="IdName">{{ user.name }}
          <div
            :class="{ UserOn: user.facilitator, UserOff: !user.facilitator }"
            @click="ToggleFacilitator"
            v-if="showEditLink && user.id"
          ></div></div>
        <div class="IdEmail" @click="showWriteMessagePopup" v-if="!authorized || user.id != currentUser.id">Написать сообщение</div>
        <div class="BtNewMethod" v-if="showMethodCreation" @click.prevent="onShowNewMethodPopup">ДОБАВИТЬ НОВЫЙ МЕТОД</div>

        <UserInfoShow
          :user="user"
          :showEditLink="showEditLink"
          @hideAction="toggleEditMode"
          v-show="!editMode"
        ></UserInfoShow>

        <UserInfoEdit
          :user="user"
          @hideAction="toggleEditMode"
          v-show="editMode"
        ></UserInfoEdit>

      </div>
    </div>

    <div class="PopUpNewMethod" id="PopUp" v-show="showNewMethodPopup">
      <div class="PopUpFon" @click.prevent="onHideNewMethodPopup"></div>
      <div class="PopUpPanel">
        <div class="PopUpBlock">
          <div class="PopUpName">НОВЫЙ МЕТОД</div>
          <div class="PopUpClose" @click.prevent="onHideNewMethodPopup"></div>
          <div class="Rline2"></div>
          <form @submit.prevent="createMethod">
            <input type="text" class="MethodName" name="name_big" placeholder="Название" v-model="method.name_big"><br>
            <input type="text" class="MethodAddName" name="name_small" placeholder="Доп. название" v-model="method.name_small"><br>
            <input type="submit" class="BtCreate" value="СОЗДАТЬ">
          </form>
          <div class="MMErorr" v-show="methodErrors">{{ methodErrors }}</div>
          <div class="MAAva" :style='{ backgroundImage: `url(${user.avatar_preview_40})` }'></div>
          <div class="MAName">{{ user.name }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import UserInfoShow from "@/components/user/UserInfoShow.vue";
import UserInfoEdit from "@/components/user/UserInfoEdit.vue";
import { ROLES } from "@/utils/roles";
import { pick } from 'lodash';
import { API_ROOT } from "@/utils/api_root";
import { mapGetters } from 'vuex';

console.log('roles', ROLES);

export default {
  components: {
    UserInfoShow, UserInfoEdit
  },
  props: {
    user: { type: Object, default: function() { return {}; } },
    allowMethodCreation: { type: Boolean, default: function() { return false; } },
    showEditLink: { type: Boolean, default: function() { return false; } }
  },
  data() {
    return {
      editMode: false,
      roles: ROLES,
      showNewMethodPopup: false,
      method: {},
      methodErrors: ""
    };
  },
  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
    ToggleFacilitator() {
      console.log('User component ToggleFacilitator this', this);
      this.user.facilitator = !this.user.facilitator;
      const params = pick(this.user, ['facilitator']);
      console.log('User component ToggleFacilitator params', params);

      this.$http.patch(`${API_ROOT}/users/${this.user.id}.json`, {user: params})
        .then(response => {
          console.log('User component saveUser success', response);
          // this.$store.commit('currentUser', response.data);
          this.flash('Данные сохранены', 'success', {timeout: 3000});
        })
        .catch(error => {
          console.log('User component error', error, error.response.data.errors);
          // this.authError = error.response.data.errors[0];
          this.flash('Ошибка сохранения', 'error');
        });
    },
    uploadAvatar(event) {
      const selectedFile = event.target.files[0]
      console.log('UserInfo onAvatarChange event', event)
      console.log('UserInfo onAvatarChange selectedFile', selectedFile)
      if (selectedFile == undefined) return;

      const formData = new FormData();
      formData.append("id", this.user.id);
      formData.append("user[avatar]", selectedFile);

      this.$http.patch(`${API_ROOT}/users/${this.user.id}.json`, formData)
        .then(response => {
          console.log('UserInfo uploadAvatar success', response);
          this.$store.commit('currentUser', response.data);
          this.flash('Данные сохранены', 'success', {timeout: 3000});
        })
        .catch(error => {
          console.log('UserInfo uploadAvatar error', error, error.response);
          // this.authError = error.response.data.errors[0];
          this.flash('Ошибка сохранения', 'error');
        });
    },
    onShowNewMethodPopup() {
      this.showNewMethodPopup = true;
    },
    onHideNewMethodPopup() {
      this.showNewMethodPopup = false;
    },
    createMethod() {
      console.log('UserInfo component createMethod this', this);
      // const params = pick(this.method, ['phone', 'link', 'description']);
      // console.log('createMethod params', params);
      this.method.author_id = this.user.id;
      console.log('createMethod this.method', this.method);
      this.methodErrors = "";

      this.$http.post(`${API_ROOT}/cards.json`, {card: this.method})
        .then(response => {
          console.log('createMethod success', response, response.data);
          const cardData = response.data;
          this.$store.commit('card', cardData);
          // this.$emit('hideAction')
          this.onHideNewMethodPopup();
          this.$router.push({ name: 'card', params: { id: cardData.id  } });
        })
        .catch(error => {
          console.log('createMethod error', error, error.response.data);
          // this.authError = error.response.data.errors[0];
          this.methodErrors = Object.values(error.response.data).join(", ");
        });
    },
    showWriteMessagePopup() {
      this.$store.commit('onShowWriteMessagePopup', this.user);
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'authorized']),
    showMethodCreation() {
      return this.allowMethodCreation && this.user.id && this.user.role != 'user'
    }
  }
};
</script>

<style>

.UserOn{
  position: absolute;
  width: 75px;
  height: 30px;
  right: -90px;
  top: 3px;
  cursor: pointer;
  border: 0px solid #666666;

  background-image: url('/img/icon-user-on.png');
  background-size: cover;
}

.UserOff{
  position: absolute;
  width: 75px;
  height: 30px;
  right: -90px;
  top: 3px;
  cursor: pointer;
  border: 0px solid #666666;

  background-image: url('/img/icon-user-off.png');
  background-size: cover;
}

.PageZg{
  position: relative;
  margin: 0px auto 20px;
  width: 1000px;
  text-align: left;
  font-family: 'Roboto Condensed', sans-serif;
  color: #888;
  font-weight: nodmal;
  font-size: 28px;
}

.IdBlock{
  position: relative;
  margin: 0px auto;
  top: 10px;
  width: 1000px;
  height: 250px;
  border: 0px solid #ccc;
}

.BtNewMethod{
  position: absolute;
  cursor: pointer;
  top: 60px;
  right: 10px;
  width: 250px;
  height: 27px;
  padding-top: 10px;
  font-family: 'Roboto Condensed', sans-serif;
  text-align: center;
  border-radius: 6px;
  font-size: 15px;
  color: #FFF;
  background-color: #37bbd6;
}

.BtNewMethod:hover{
  background-color: #039eb0;
}

.BtEditUserInfo{
  position: absolute;
  cursor: pointer;
  top: 25px;
  right: 20px;
  width: 20px;
  height: 20px;
  background-image: url(../assets/img/edit.png);
  background-size: cover;
  opacity: 0.4;
}

.BtEditUserInfo:hover{
  opacity: 1;
}

.BtAddUserInfo{
  position: absolute;
  cursor: pointer;
  top: 25px;
  right: 20px;
  width: 20px;
  height: 20px;
  background-image: url(../assets/img/enter.png);
  background-size: cover;
  opacity: 0.4;
}

.BtAddUserInfo:hover{
  opacity: 1;
}

.AvaBig{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 220px;
  height: 220px;
  background-color: #dcdcdc;
  background-size: cover;
}

.AvaBt {
  position: absolute;
  top: 180px;
  left: 5px;
  width: 210px;
  height: 35px;
  border-radius: 4px;
  background-color: #888;
  text-align: center;
  line-height: 35px;
  font-family: "Roboto";
  font-size: 9pt;
  color: #fff;
  cursor: pointer;
  opacity: 0.6;
}

.AvaBt:hover{
  opacity: 0.85;
}

.IdName{
  position: absolute;
  top: 55px;
  left: 280px;
  height: 30px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 28px;
  font-weight: bold;
  color: #000000;
}

.IdEmail{
  position: absolute;
  padding-left: 4px;
  top: 90px;
  left: 277px;
  width: 270px;
  height: 25px;
  border: 0px solid #d7d7d7;
  border-radius: 3px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 14px;
  color: #999999;
  cursor: pointer;
}

.IdStatus{
  position: absolute;
  padding-left: 22px;
  padding-top: 2px;
  top: 10px;
  left: 275px;
  width: 400px;
  height: 30px;
  font-family: 'Roboto Condensed', sans-serif;
  background-repeat: no-repeat;
  font-size: 14px;
  color: #000000;
}

.user{
  background-image: url('../assets/img/point-user.png');
}

.moderator{
  background-image: url('../assets/img/point-moder.png');
}

.admin{
  background-image: url('../assets/img/point-admin.png');
}

.IdRazdel {
  position: absolute;
  top: 120px;
  left: 255px;
  width: 750px;
  height: 205px;
  border-top: 1px solid #d7d7d7;
}

.IdRazdel.Edit {
  background-color: #fef7ca;
}

.opIdPhone {
  position: absolute;
  top: 15px;
  left: 27px;
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  color: #b4b4b4;
}

.IdEmail {
  position: absolute;
  padding-left: 4px;
  top: 90px;
  left: 277px;
  width: 270px;
  height: 25px;
  border: 0px solid #d7d7d7;
  border-radius: 3px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 14px;
  color: #999999;
}

.IdPhone {
  position: absolute;
  padding-left: 5px;
  padding-top: 5px;
  top: 27px;
  left: 20px;
  width: 270px;
  height: 25px;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 18px;
  color: #000000;
  background-color: #fff;
}

.opIdSite {
  position: absolute;
  top: 65px;
  left: 27px;
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  color: #b4b4b4;
}

.IdSite {
  position: absolute;
  padding-left: 5px;
  padding-top: 9px;
  top: 77px;
  left: 20px;
  width: 270px;
  height: 25px;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 13px;
  color: #888;
  background-color: #fff;
}

.opIdFacilitator {
  position: absolute;
  top: 115px;
  left: 27px;
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  color: #b4b4b4;
}

.IdFacilitator {
  position: absolute;
  padding-left: 5px;
  padding-top: 9px;
  top: 127px;
  left: 20px;
  width: 270px;
  height: 25px;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 13px;
  color: #888;
  background-color: #fff;
}

.opIdOpis {
  position: absolute;
  top: 15px;
  left: 317px;
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  color: #b4b4b4;
}

.IdOpis {
  position: absolute;
  padding-left: 7px;
  padding-top: 4px;
  top: 27px;
  left: 310px;
  width: 380px;
  height: 80px;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  color: #888;
  background-color: #fff;
}

.PopUpNewMethod{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background-color: #323938;
  border-top: 1px solid #ccc; */
  z-index: 10;
}

.PopUpFon{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: #323938;
  opacity: 0.9;

}

.PopUpPanel{
  position: absolute;
  left: 50%;
  top: 15%;
}

.PopUpNewMethod .PopUpBlock{
  height: 360px;
}

.PopUpNewMethod .PopUpName{
  color: #37bbd6;
  font-style: bold;
}

.Rline2{
  position: absolute;
  top: 230px;
  left: 30px;
  width: 340px;
  border-top: 1px solid #ccc;
}

.MethodName{
  position: absolute;
    top: 100px;
    left: 20px;
    width: 240px;
    height: 40px;
    padding-left: 10px;
  border-radius: 6px;
    border: 1px solid #ccc;
  margin-left: 15px;
    margin-top: 5px;
    font-family: 'Roboto Condensed', sans-serif;
    color: #000;
    font-weight: bold;
    font-size: 26px;
}

.MethodAddName{
  position: absolute;
    top: 160px;
    left: 20px;
    width: 240px;
    height: 40px;
    padding-left: 10px;
  border-radius: 6px;
    border: 1px solid #ccc;
  margin-left: 15px;
    margin-top: 0px;
    font-family: 'Roboto Condensed', sans-serif;
    color: #000;
    font-weight: nodmal;
    font-size: 17px;
}

.MMErorr{
  position: absolute;
    top: 240px;
    left: 30px;
    width: 240px;
    height: 40px;
    padding-left: 10px;
  text-align: left;
    font-family: "Roboto";
    font-size: 9pt;
    color: #e50808;
}

.MAAva{
  position: absolute;
    top: 290px;
    left: 40px;
    width: 40px;
    height: 40px;
    background-size: cover;
}

.MAName{
  position: absolute;
    top: 295px;
    left: 95px;
    width: 80px;
    height: 30px;
  font-family: 'Roboto Condensed', sans-serif;
    color: #000;
    font-weight: nodmal;
    font-size: 13px;
}

.BtCreate{
  position: absolute;
  top: 290px;
  right: 40px;
  width: 150px;
  height:40px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 18px;
  color: #fff;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #37bbd6
}
</style>
